import * as React from 'react'; // https://github.com/aelbore/esbuild-jest/issues/61
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { isInfoBlockElement } from '../../types/guards';
import {
  type InfoBlockElement,
  type InfoBlockType,
} from '../../types/aha-editor';
import {
  INFO_BLOCK_DEPRECATED_CLASS_PREFIX,
  infoBlockTypes,
  isInfoBlockNode,
} from '../../plugins/InfoBlockPlugin/utils';
import isLineBreak from '../../serialization/helpers/isLineBreak';

class SerializerInfoBlock extends Serializer {
  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!isInfoBlockElement(node)) {
      return;
    }

    return (
      <p data-callout-box-type={node.type}>
        <span>{children}</span>
        {isLineBreak(node) && <br />}
      </p>
    );
  }

  static deserialize({
    el,
    markAttributes,
    next,
  }: DeserializeArguments): InfoBlockElement | undefined {
    if (!isInfoBlockNode(el)) return;

    const { calloutBoxType } = el.dataset;
    const deprecatedTypeClassName = Array.from(el.classList).find((className) =>
      className.startsWith(INFO_BLOCK_DEPRECATED_CLASS_PREFIX)
    );
    let type = (calloutBoxType ||
      deprecatedTypeClassName?.replace(
        INFO_BLOCK_DEPRECATED_CLASS_PREFIX,
        ''
      )) as InfoBlockType | undefined;
    if (!type) {
      return;
    }

    if (!infoBlockTypes.includes(type)) {
      type = 'infoBlock';
    }

    return {
      type,
      children: next(el.childNodes, markAttributes),
    };
  }
}

export default SerializerInfoBlock;
